import { render } from "./MovementPage.vue?vue&type=template&id=6c70d5d4&scoped=true"
import script from "./MovementPage.vue?vue&type=script&lang=js"
export * from "./MovementPage.vue?vue&type=script&lang=js"

import "./MovementPage.vue?vue&type=style&index=0&id=6c70d5d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c70d5d4"]])

export default __exports__